import { getFlagPosition, FLAG_TILE_PX } from '../../utils/flagPositions';
import flagsSpriteUrl from '../../assets/flags.png';
import styles from './Flag.module.scss';

interface FlagProps {
  /** BCP-47 locale (e.g. 'en-US', 'ar-SA'). */
  locale: string;
  /** Override the rendered title — defaults to the locale code. */
  title?: string;
  className?: string;
}

/**
 * Sprite-driven country flag, 24×24px. Reads position from
 * `flagPositions.ts`. Returns null when locale has no mapping — renders
 * nothing rather than a placeholder tile.
 *
 * The sprite URL is injected as a CSS custom property on the element so
 * the SCSS module can reference it cleanly via `background-image: var(...)`.
 */
export function Flag({ locale, title, className }: FlagProps) {
  const pos = getFlagPosition(locale);
  if (!pos) return null;

  const classes = [styles.flag, className].filter(Boolean).join(' ');
  const style = {
    backgroundPosition: `-${pos.col * FLAG_TILE_PX}px -${pos.row * FLAG_TILE_PX}px`,
    ['--ds-flag-sprite-url' as string]: `url(${flagsSpriteUrl})`,
  } as React.CSSProperties;

  return <span className={classes} style={style} title={title ?? locale} aria-hidden="true" />;
}
